import { render } from "./GenogramMain.vue?vue&type=template&id=1bbb2e09"
import script from "./GenogramMain.vue?vue&type=script&lang=js"
export * from "./GenogramMain.vue?vue&type=script&lang=js"

import "./GenogramMain.vue?vue&type=style&index=0&id=1bbb2e09&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__